import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './lib/appInsights';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './config/msalConfig';
import App from './App';

// Initialize MSAL then render — AuthContext handles the redirect promise
msalInstance.initialize().then(() => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>
  );
});
